import * as moment from 'moment/moment';

export type DateInput = Exclude<moment.MomentInput, 'Moment' | 'MomentInputObject'>;
